module.exports = __webpack_public_path__ + "static/media/man-white.69d439f6.svg";